import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "radius", "className"];
/* eslint-disable no-use-before-define */
import React from 'react';
import PropTypes from 'prop-types';
import { default as _ContentLoader } from 'react-content-loader';
import cond from 'lodash/fp/cond';
import isNil from 'lodash/fp/isNil';
var hasChildren = function hasChildren(_ref) {
  var children = _ref.children;
  return !isNil(children);
};
var renderChildren = function renderChildren(_ref2) {
  var children = _ref2.children;
  return children;
};
var isRect = function isRect(_ref3) {
  var type = _ref3.type;
  return type === ContentLoader.RECT;
};
var isCircle = function isCircle(_ref4) {
  var type = _ref4.type;
  return type === ContentLoader.CIRCLE;
};
var renderRect = function renderRect(_ref5) {
  var _ref5$rx = _ref5.rx,
    rx = _ref5$rx === void 0 ? 3 : _ref5$rx,
    _ref5$ry = _ref5.ry,
    ry = _ref5$ry === void 0 ? 3 : _ref5$ry;
  return /*#__PURE__*/React.createElement("rect", {
    width: '100%',
    height: '100%',
    rx: rx,
    ry: ry
  });
};
var renderCircle = function renderCircle(_ref6) {
  var radius = _ref6.radius;
  return /*#__PURE__*/React.createElement("circle", {
    cx: radius,
    cy: radius,
    r: radius
  });
};
var ContentLoader = function ContentLoader(props) {
  var width = props.width,
    height = props.height,
    radius = props.radius,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var content = cond([[hasChildren, renderChildren], [isRect, renderRect], [isCircle, renderCircle]])(props);
  var wrapperHeight = isCircle(props) ? radius * 2 : height;
  var wrapperWidth = isCircle(props) ? radius * 2 : width;
  return /*#__PURE__*/React.createElement(_ContentLoader, _extends({
    className: "ContentLoader ".concat(className),
    height: wrapperHeight,
    width: wrapperWidth
  }, remainingProps), content);
};
ContentLoader.RECT = 'rect';
ContentLoader.CIRCLE = 'circle';
ContentLoader.defaultProps = {
  speed: 2,
  height: 14,
  width: '100%',
  radius: 16,
  type: 'rect',
  className: '',
  title: ''
};
ContentLoader.propTypes = {
  speed: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['rect', 'circle', ContentLoader.RECT, ContentLoader.CIRCLE]),
  radius: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
export default ContentLoader;